import theme from "@vromo/ui/components/theme";

export default ({
    container: {
        backgroundColor: theme.ultraLightGrey, 
        padding: '0 12px',
        borderRadius: 4,
    },
    input: {
        marginBottom: 8, 
        width: 'auto',
    },
    widgetContainer: {
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        marginTop: 12,
    },
    promotionContainer: {
        display: 'flex', 
        flexDirection: 'row'
    },
    imageSelectContainer: {
        padding: 8
    },
    checkbox: {
        marginRight: 8,
    },
    buttonContainer: {
        marginTop: 12,
    },
    addButton: {
        marginLeft: 8
    },
});